import React from "react";
import { Briefcase, Filter, Calendar, TrendingUp, Search, Users, Medal } from "lucide-react";

const LinkedInFilterSection = ({
  linkedInFilter,
  setLinkedInFilter,
  dateFilter,
  setDateFilter,
  engagementFilter,
  setEngagementFilter,
  companyFilter,
  setCompanyFilter,
  searchInputValue,
  setSearchInputValue,
  filteredCount,
  totalCount,
}) => {
  const FilterButton = ({ label, onClick, isActive, icon }) => (
    <button
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
      className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-200 flex items-center space-x-1 ${
        isActive
          ? "bg-purple-100 text-purple-800 border border-purple-200"
          : "bg-white hover:bg-gray-50 text-gray-700 border border-gray-200"
      }`}
    >
      {icon && icon}
      <span>{label}</span>
    </button>
  );

  return (
    <div className="bg-white shadow-sm rounded-lg p-4 mb-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-4 space-y-3 sm:space-y-0">
        <h2 className="text-lg font-medium text-gray-800">LinkedIn Filters</h2>

        <div className="w-full sm:w-auto relative">
          <div className="relative">
            <input
              type="text"
              placeholder="Search in LinkedIn results..."
              className="w-full sm:w-64 pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              value={searchInputValue}
              onChange={(e) => setSearchInputValue(e.target.value)}
            />
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} />
          </div>
        </div>

        <div className="text-sm text-gray-500">
          Showing {filteredCount || 0} of {totalCount || 0} posts
        </div>
      </div>

      <div className="space-y-3">
        <div>
          <h3 className="text-sm font-medium text-gray-700 mb-2">Intent Level</h3>
          <div className="flex flex-wrap gap-2">
            <FilterButton label="All" onClick={() => setLinkedInFilter("All")} isActive={linkedInFilter === "All"} />
            <FilterButton
              label="High Intent"
              onClick={() => setLinkedInFilter("High Intent")}
              isActive={linkedInFilter === "High Intent"}
              icon={<TrendingUp size={12} className="mr-1" />}
            />
            <FilterButton
              label="Medium Intent"
              onClick={() => setLinkedInFilter("Medium Intent")}
              isActive={linkedInFilter === "Medium Intent"}
            />
            <FilterButton label="Low Intent" onClick={() => setLinkedInFilter("Low Intent")} isActive={linkedInFilter === "Low Intent"} />
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-700 mb-2">Account Type</h3>
          <div className="flex flex-wrap gap-2">
            <FilterButton label="All Accounts" onClick={() => setCompanyFilter("All")} isActive={companyFilter === "All"} />
            <FilterButton
              label="Company Posts"
              onClick={() => setCompanyFilter("Company")}
              isActive={companyFilter === "Company"}
              icon={<Briefcase size={12} className="mr-1" />}
            />
            <FilterButton
              label="Individual Posts"
              onClick={() => setCompanyFilter("Person")}
              isActive={companyFilter === "Person"}
              icon={<Users size={12} className="mr-1" />}
            />
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-700 mb-2">Engagement</h3>
          <div className="flex flex-wrap gap-2">
            <FilterButton label="All Engagements" onClick={() => setEngagementFilter("All")} isActive={engagementFilter === "All"} />
            <FilterButton
              label="High Engagement"
              onClick={() => setEngagementFilter("High")}
              isActive={engagementFilter === "High"}
              icon={<Medal size={12} className="mr-1" />}
            />
            <FilterButton
              label="Medium Engagement"
              onClick={() => setEngagementFilter("Medium")}
              isActive={engagementFilter === "Medium"}
            />
            <FilterButton label="Low Engagement" onClick={() => setEngagementFilter("Low")} isActive={engagementFilter === "Low"} />
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-700 mb-2">Time Period</h3>
          <div className="flex flex-wrap gap-2">
            <FilterButton label="All Time" onClick={() => setDateFilter("all")} isActive={dateFilter === "all"} />
            <FilterButton
              label="Last 24 hours"
              onClick={() => setDateFilter("24h")}
              isActive={dateFilter === "24h"}
              icon={<Calendar size={12} className="mr-1" />}
            />
            <FilterButton label="Last 7 days" onClick={() => setDateFilter("7d")} isActive={dateFilter === "7d"} />
            <FilterButton label="Last 30 days" onClick={() => setDateFilter("30d")} isActive={dateFilter === "30d"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkedInFilterSection;
